/* AQUON Hero Banner slider. Fade or slide, autoplay + loop, arrows, dots,
   counter + progress, touch swipe + mouse drag, video play/pause, reduced-motion
   and off-screen aware. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.ahbInit === '1') return; root.dataset.ahbInit = '1';

    var isFade = (root.dataset.ahbMode || 'slide') === 'fade';
    var autoplay = root.dataset.ahbAutoplay === 'true' && !reduce;
    var interval = parseInt(root.dataset.ahbInterval, 10) || 5000;
    var loop = root.dataset.ahbLoop !== 'false';
    var swipe = root.dataset.ahbSwipe !== 'false';
    var drag = root.dataset.ahbDrag !== 'false';

    var vp = root.querySelector('[data-ahb-viewport]');
    var track = root.querySelector('[data-ahb-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ahb-slide]'));
    var counter = root.querySelector('[data-ahb-counter]');
    var fill = root.querySelector('[data-ahb-progress-fill]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ahb-dot]'));
    var prevBtn = root.querySelector('[data-ahb-prev]');
    var nextBtn = root.querySelector('[data-ahb-next]');
    var n = slides.length;
    var idx = 0, timer = null;
    var frame = root.querySelector('.ahb__frame');

    // Per-slide height (Variant 3 only): when the active slide carries a
    // height, the frame takes it; otherwise it reverts to the CSS/section default.
    function applyHeight() {
      if (!frame) return;
      var active = slides[idx];
      if (!active) { frame.style.height = ''; return; }
      var mobile = window.matchMedia('(max-width: 749.98px)').matches;
      var h = mobile ? (active.getAttribute('data-ahb-slide-h-m') || active.getAttribute('data-ahb-slide-h'))
                     : active.getAttribute('data-ahb-slide-h');
      if (h && parseInt(h, 10) > 0) frame.style.height = parseInt(h, 10) + 'px';
      else frame.style.height = '';
    }
    window.addEventListener('resize', applyHeight);
    // Crossing the mobile/desktop breakpoint swaps which video is visible; play
    // the newly-visible one.
    window.matchMedia('(max-width: 749.98px)').addEventListener('change', function () { playActiveVideo(); });

    function playActiveVideo() {
      slides.forEach(function (s, i) {
        // A slide can hold both a desktop and a mobile video; only one is shown
        // at a time (CSS media query). Play the VISIBLE video on the active slide,
        // pause everything else. offsetParent is null when display:none.
        var vids = s.querySelectorAll('video'); if (!vids.length) return;
        vids.forEach(function (v) {
          if (i === idx && v.offsetParent !== null) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      });
    }
    function render() {
      if (isFade) slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      else track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
      if (counter) counter.textContent = (idx + 1) + '/' + n;
      if (fill) fill.style.width = ((idx + 1) / n * 100) + '%';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      applyHeight();
      playActiveVideo();
    }
    function goTo(i) { idx = loop ? (i + n) % n : Math.max(0, Math.min(n - 1, i)); render(); }
    function next() { goTo(idx + 1); }
    function prev() { goTo(idx - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (!autoplay || n <= 1) return; stop(); timer = setInterval(next, interval); }
    function restart() { stop(); start(); }

    if (n <= 1) { render(); return; }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); restart(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); restart(); } else if (e.key === 'ArrowRight') { next(); restart(); }
    });

    // swipe (touch) + drag (mouse)
    var startX = 0, curX = 0, dragging = false;
    function down(x) { dragging = true; startX = curX = x; stop(); if (!isFade) track.classList.add('is-dragging'); }
    function move(x) { if (!dragging) return; curX = x; if (!isFade && vp) { var pct = (x - startX) / vp.clientWidth * 100; track.style.transform = 'translateX(' + (-idx * 100 + pct) + '%)'; } }
    function upEnd() { if (!dragging) return; dragging = false; if (!isFade) track.classList.remove('is-dragging'); var dx = curX - startX, th = 40; if (dx < -th) next(); else if (dx > th) prev(); else render(); start(); }
    if (swipe) {
      root.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
      root.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      root.addEventListener('touchend', upEnd);
    }
    if (drag) {
      root.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button === 0) down(e.clientX); });
      root.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') move(e.clientX); });
      root.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') upEnd(); });
      root.addEventListener('pointercancel', function (e) { if (e.pointerType === 'mouse') upEnd(); });
    }

    render();
    start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { start(); playActiveVideo(); }
          else { stop(); slides.forEach(function (s) { s.querySelectorAll('video').forEach(function (v) { v.pause(); }); }); }
        });
      }, { threshold: 0.15 }).observe(root);
    }
  }

  function initAll() { document.querySelectorAll('[data-ahb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-ahb]').forEach(init); });
})();
